module.exports = { "default": require("core-js/library/fn/object/define-property"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./node_modules/.6.26.0@babel-runtime/core-js/object/define-property.js
// module id = 231
// module chunks = 1